import { reactive } from 'vue';

import { ClientInfoI } from '@/support/interfaces';

type StateType = {
  appStarted: boolean;
  authToken: string;
  referer: string;
  language: string;
  clientInfo?: ClientInfoI;
  isPageOnline: boolean;
  loaderOpened: boolean;
  trackingClientRemainingTime: number;
  baseUrl: string;
  authType: 'OIDC' | 'original';
  refreshToken: string;
  idToken: string;
  refreshTokenIntervalId?: number;
};

const state = reactive<StateType>({
  appStarted: false,
  authToken: '',
  referer: '',
  language: '',
  clientInfo: undefined,
  isPageOnline: true,
  loaderOpened: true,
  trackingClientRemainingTime: 0,
  baseUrl: import.meta.env.VITE_APP_BASE_URL,
  authType: 'original',
  refreshToken: '',
  idToken: '',
});

export default state;
